import Button from '@/components/Button.jsx';
import PageSearch from './PageSearch.jsx';
import { Fragment } from 'react';

const PageActionRow = ({ inputRef, placeholder, useSearch = false, searchKey, searchDisabled = false, searchProps, actions, filters }) => {
  return (
    <div className={'comp-page-action-row'}>
      <div className={'left'}>
        {useSearch && <PageSearch inputRef={inputRef} placeholder={placeholder} searchKey={searchKey} {...searchProps} disabled={searchDisabled} />}
        {filters}
      </div>
      <div className={'right'}>
        {actions?.length > 0 &&
          actions.map((action, index) =>
            action.customComponent ? (
              <Fragment key={index}>{action.customComponent}</Fragment>
            ) : (
              <Button key={index} {...action} onClick={() => action?.onClick?.(action)}>
                {action.label}
              </Button>
            )
          )}
      </div>
    </div>
  );
};

export default PageActionRow;
